import { set } from "@/utils/vuex";

export default {
  resetState(state) {
    Object.assign(state, state.getDefaultState());
  },

  setLoading: set("loading"),

  setBillingReports: set("billing_reports"),
  pushBillingReport(state, value) {
    state.billing_reports.push(value);
  },
  spliceBillingReports(state, data) {
    state.billing_reports.splice(data.index, 1, data.data);
  },
};
